import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "lorenNumber",
    standalone: false
})
export class LorenNumberPipe implements PipeTransform {
  transform(
    value: number | string,
    numberOfDigitsAfterComma: number = null
  ): string {
    const numberValue = Number(value);

    if (!value || Number.isNaN(numberValue)) {
      return String(value);
    }

    if (Number.isInteger(numberValue)) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    } else {
      let result: string = value.toString();
      if (numberOfDigitsAfterComma) {
        result = Number(
          numberValue.toFixed(numberOfDigitsAfterComma)
        ).toString();
      }

      const parts = result.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");

      return parts.join(".");
    }
  }
}
